import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import VendorStatement from '../../components/AP/vendorStatement';
import { fetchVendorStatement } from '../../actions/arap_actions';
import { setValue, fetchPurchasesVendorDetail } from '../../actions/sales_actions';
import { fetchVendors, fetchVendorDetail, resetCurrentVendor } from '../../actions/vendors_actions';
import { printAPReport, printWarehouseReceive } from '../../actions/print_actions';

let vendorStatement = reduxForm({
  form: 'vendorStatement',
})(VendorStatement);

const selector = formValueSelector('vendorStatement');

function mapStateToProps(state) {
    const typeRadios = selector(state, 'typeRadios');
    const Year = selector(state, 'Year');
    const Month = selector(state, 'Month');
    const StatementType = selector(state, 'StatementType');
    const Quarter = selector(state, 'Quarter');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    const Vendor = selector(state, 'Vendor');

    return {
        typeRadios,
        Year,
        Month,
        StatementType,
        Quarter,
        FromDate,
        ToDate,
        Vendor,
        vendorStatementIsLoading: state.arap.vendorStatementIsLoading,
        vendorStatement: state.arap.vendorStatement,
        vendorStatementError: state.arap.vendorStatementError,
        vendors: state.vendors.all,
        vendorsIsLoading: state.vendors.isLoading,
        vendorsError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        vendorDetailIsLoading: state.vendors.detailIsLoading,
        vendorDetailError: state.vendors.detailError,
        purchasesVendorDetails: state.salesOrders.purchasesVendorDetails,
        purchasesVendorDetailsIsLoading: state.salesOrders.purchasesVendorDetailsIsLoading,
        purchasesVendorDetailsError: state.salesOrders.purchasesVendorDetailsError,
        currentVendor: state.vendors.currentVendor,
        requestingApReport: state.print.requestingApReport,
        apReport: state.print.apReport,

        requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
        warehouseReceivePdf: state.print.warehouseReceivePdf,
        selectedCompany: state.header.selectedCompany,
    };
}

export default connect(mapStateToProps, {
  setDefaultOfForm,
  fetchVendorStatement,
  setValue,
  fetchVendors,
  fetchVendorDetail,
  fetchPurchasesVendorDetail,
  resetCurrentVendor,
  printAPReport,
  printWarehouseReceive,
})(vendorStatement);



// WEBPACK FOOTER //
// ./master/jsx/containers/AP/vendorStatement.jsx